import { css } from '@emotion/core';

import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  LINK_COLOR,
} from './styleVariables';

export const passwordStyleOverrides = css`
  &:disabled {
    background: ${DISABLED_BACKGROUND_COLOR};
    border-color: ${DISABLED_BORDER_COLOR};
  }
`;

export const secondaryLink = css`
  color: ${LINK_COLOR};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`;
